import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class TypeAssertionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.TypeAssertionExpression;
    }
    visitNode(_sb, _expr, _options) {
    }
}

//# sourceMappingURL=TypeAssertionCompiler.js.map
